<template>
  <div class="wrapper">
    <div class="login-frame">
      <div class="login-form">
        <p class="login-title">重新设置密码</p>
        <el-form
          :rules="loginRules"
          ref="loginForm"
          :model="resetPasswordArgs"
          :show-message="false"
        >
          <el-row>
            <el-col>
              <el-form-item prop="cellphone">
                <el-input
                  placeholder="手机号"
                  prefix-icon="iconfont icon-yonghu01-copy"
                  v-model="resetPasswordArgs.cellphone"
                >
                  <el-button
                    slot="append"
                    class="sendValidationCode-btn"
                    v-if="sendValidationCodeCountDown === 0"
                    @click.native.prevent="sendValidationCode()"
                    >发送验证码</el-button
                  >
                  <el-button
                    slot="append"
                    v-if="sendValidationCodeCountDown > 0"
                    >已发送（{{ sendValidationCodeCountDown }}）</el-button
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="validationCode">
                <el-input
                  placeholder="验证码"
                  prefix-icon="iconfont icon-yonghu01-copy"
                  v-model="resetPasswordArgs.validationCode"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="newPassword">
                <el-input
                  placeholder="密码"
                  prefix-icon="iconfont icon-yuechi"
                  v-model="resetPasswordArgs.newPassword"
                  type="password"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="newPassword2">
                <el-input
                  placeholder="再次输入密码"
                  prefix-icon="iconfont icon-yuechi"
                  v-model="resetPasswordArgs.newPassword2"
                  type="password"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row v-if="this.resetPasswordArgs.account!=''">
            <el-col>
                <span style="height:50px;color:gray">提示：您的登录账户是</span> <span style="color:red">{{resetPasswordArgs.account}}</span>
            </el-col>
          </el-row> -->

          <el-row>
            <el-col>
              <el-form-item>
                <el-button
                  type="primary"
                  class="login-btn"
                  @click.native.prevent="resetPassword()"
                  plain
                  >确 认</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item>
                <el-button
                  type="primary"
                  class="register-btn"
                  @click.native.prevent="handleToLogin"
                  plain
                  >返回登录</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- <div class="copy-right"></div> -->
  </div>
</template>
<script>
import { setToken } from "@/utils/auth";
import { hex_md5 } from "@/utils/MD5";

export default {
  name: "index",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码；"));
      } else {
        if (this.resetPasswordArgs.newPassword2 !== "") {
          this.$refs.loginForm.validateField("newPassword2");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.resetPasswordArgs.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      resetPasswordArgs: {
        validationCode: "",
        cellphone: "",
        newPassword: "",
        newPassword2: "",
        account: "",
      },
      loginRules: {
        cellphone: [
          { required: true, message: "请输入手机号；", trigger: "change" },
        ],
        validationCode: [
          { required: true, message: "请输入验证码；", trigger: "change" },
        ],
        newPassword: [{ validator: validatePass, trigger: "change" }],
        newPassword2: [{ validator: validatePass2, trigger: "change" }],
      },
      sendValidationCodeCountDown: 0,
      validationCodeInterval: 0,
    };
  },
  created() {},
  mounted() {
    this.validationCodeInterval = setInterval(() => {
      this.sendValidationCodeCountDown > 0
        ? (this.sendValidationCodeCountDown -= 1)
        : "";
    }, 1000);

    // 绑定enter事件
    // this.enterKeyup();
  },
  destroyed() {
    clearInterval(this.validationCodeInterval);

    // 销毁enter事件
    // this.enterKeyupDestroyed();
  },

  methods: {
    //  enterKeyupDestroyed() {
    //     document.removeEventListener("keyup", this.enterKey);
    // },
    // enterKeyup() {
    //     document.addEventListener("keyup", this.enterKey);
    // },
    // enterKey(event) {
    //      const code = event.keyCode
    //             ? event.keyCode
    //             : event.which
    //                 ? event.which
    //                 : event.charCode;
    //         if (code == 13) {
    //             this.resetPassword();
    //         }
    // },
   
    // //先根据手机号获取用户信息，再发送验证代码
    // getUserAccount()
    // {
    //     this.$refs.loginForm.validateField("cellphone", valid =>
    //         {
    //             if (!valid)
    //             {
    //                 this.$userApi.getAccountByCellphone(this.resetPasswordArgs.cellphone)
    //                     .then(res =>
    //                     {
    //                         if (res.data.successful)
    //                         {
    //                            this.resetPasswordArgs.account = res.data.data;
    //                            this.sendValidationCode();
    //                         }
    //                         else
    //                         {
    //                           this.resetPasswordArgs.account = "";
    //                             this.$alert(res.data.message, "提示");
    //                         }
    //                     });
    //             }
    //             else{
    //                 this.$uiHelper.showValidationMessage_Text(valid);
    //                 return;
    //             }

    //         });
    // },
    sendValidationCode() {
      this.$refs.loginForm.validateField("cellphone", (valid) => {
        // console.log("valid:");
        // console.log(valid);

        if (!valid) {
          this.$domainApi
            .sendValidationCode({
              cellphoneNumber: this.resetPasswordArgs.cellphone,
            })
            .then((res) => {
              if (res.data.successful) {
                this.sendValidationCodeCountDown = 60;
                this.$alert("验证码已发送", "提示");
              } else {
                this.$alert(res.data.message, "提示");
              }
            });
        } else {
          this.$uiHelper.showValidationMessage_Text(valid);
          return;
        }
      });
    },
    resetPassword() {
      this.$refs.loginForm.validate((valid, data) => {
        if (valid == false) {
          this.$uiHelper.showValidationMessage(valid, data);
          return;
        }

        let params = {
          cellphone: this.resetPasswordArgs.cellphone,
          validationCode: this.resetPasswordArgs.validationCode,
          newPassword: hex_md5(
            this.resetPasswordArgs.newPassword
          ).toUpperCase(),
        };

        this.$userContextApi.resetPassword(params).then((res) => {
          if (res.data.successful) {
            this.$alert(
              "修改密码成功。您的登录账户是：" + res.data.data.account,
              "提示",
              {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.$router.push({ path: "/views/login" });
                },
              }
            );
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
    handleToLogin() {
      this.$router.push({ path: "/login" });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
.wrapper {
  position: relative;
  height: 100vh;
  background: url("../assets/login-bg.jpg"); //center no-repeat;
  background-size: 100%;
  font-size: 14px;
  //background-size: 100% 100%;
  .login-frame {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 400px;
    // margin: 0 50%;
    // height: 440px;
    margin-top: -250px;
    margin-left: -180px;
    .iconfont {
      font-size: 20px;
    }
    .iconfont.icon-yuechi {
      font-size: 25px;
    }
    .login-title {
      color: #36b5f8;
      font-size: 17px;
      margin-bottom: 22px;
    }

    .login-btn {
      font-size: 16px;
      color: #fff;
      background-color: #36b5f8;
      border-top-style: none;
      border-right-style: none;
      border-bottom-style: none;
      border-left-style: none;
      padding-top: 8px;
      padding-bottom: 8px;
      margin-top: 15px;
      width: 100%;
      height: 37px;
      cursor: pointer;
    }
    .sendValidationCode-btn {
      color: #36b5f8;
      background-color: #fff;
      cursor: pointer;
      border-top-style: none;
      border-right-style: none;
      border-bottom-style: none;
      border-left-style: none;
      height: 37px;
      padding-top: 8px;
      padding-bottom: 8px;
      font-size: 14px;
    }
    .register-btn {
      font-size: 16px;
      color: #36b5f8;
      background-color: #fff;
      border-color: #36b5f8;
      padding-top: 8px;
      padding-bottom: 8px;
      width: 100%;
      height: 37px;
      cursor: pointer;
    }
    .login-form {
      position: relative;
      height: 440px;
      padding: 30px;
      background-color: #fff;
      // border-radius: 5px;
      // box-shadow: 0 0 5px 2px #ccc;
      z-index: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/forgotPassword.vue